const DataManagementJobState = {
    Pending: 1,
    InProcess: 2,
    Done: 3,
    Failed: 4,
};
export default DataManagementJobState;
